import {Observable, of} from 'rxjs';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {ErrorService} from '../services/error-service.service';
import {AuthenticationService} from "./authentication.service";

@Injectable()
export class GuardService implements CanActivate {


    constructor(private router: Router,
                private http: HttpClient,
                private errorService: ErrorService,
                private authService: AuthenticationService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        if (!!route.data) {
            if (!!route.data.moduleId) {
                console.info('Route requires module:', route.data.moduleId);
                return this.authService.modules()
                    .pipe(map(modules => modules.indexOf(route.data.moduleId) !== -1));
            }

            if (route.data.authenticated) {
                console.info('Route requires authentication:', route.data.moduleId);
                return this.authService.user()
                    .pipe(map(user => {
                        if (!user) {
                            console.warn(`Refusing to follow route "${state.url}" because user is not authenticated.`);
                            return false;
                        }
                        return true;
                    }));
            }
        }

        // no module id restriction
        return of(true);
    }

}
